import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRoleList = createAsyncThunk("fetchRoleList", async () => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`roles/list`, config);
	
	return response.data.data;
});

const roleListSlice = createSlice({
	name: "roleList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetStateRoleList: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRoleList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchRoleList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchRoleList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetStateRoleList } = roleListSlice.actions;
export default roleListSlice.reducer;
